var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QS-common-table',{attrs:{"data":_vm.tableData,"columns":_vm.writeoffTableColumns,"row-key":"id","pagination":_vm.paginationData},on:{"change":_vm.paginationChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }